import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef, useContext } from 'react';
import { FCTheme } from '../../../theming/FCTheme.js';
import { StyledTextarea } from './styles.js';
var Textarea = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
      inError = props.inError,
      rest = __rest(props, ["id", "inError"]);

  var theme = useContext(FCTheme);
  return /*#__PURE__*/React.createElement(StyledTextarea, __assign({
    inError: inError,
    id: id,
    ref: ref,
    theme: theme.theme
  }, rest));
});
Textarea.displayName = 'Textarea';
export default Textarea;